<template>
  <div>
    <search
      v-if="isSearch"
      :delUrl="delUrl"
      @searchData="searchData"
      @resetData="searchData"
      :parentsList="parentsList"
    ></search>
    <refreshbtn @refesh="refesh" :isBetWeen="true">
      <!-- v-if="!userInfo.is_outer" -->
      <template slot="left_btn">
        <!-- <el-button size="small" type="success" @click="batchlaunch"
            >批量上线</el-button
          > -->
        
        <!-- v-has="apiUrl.check" -->
        <el-button
          size="small"
          type="success"
          @click="batchCheck"
          >批量审核</el-button
        >
        <!-- v-has="apiUrl.delete" -->
        <el-button
          size="small"
          type="success"
          @click="deleteData"
          >一键删除</el-button
        >
        <!-- v-has="apiUrl.batchUpdate" -->
        <el-button
          size="small"
          type="success"
          @click="remoteOperation"
          >批量更新</el-button
        >
        <!-- v-has="apiUrl.accept" -->
        <el-button
          size="small"
          type="success"
          @click="acceptData"
          >批量接单</el-button
        >
      </template>
      <template slot="search-btns">
        <el-button
          title="普通搜索"
          size="small"
          icon="el-icon-search"
          @click="isSearch = !isSearch"
        ></el-button>
      </template>
    </refreshbtn>
    <dataFillTable
      :headerList="headerList"
      :tableData="tableData"
      @editData="editData"
      :total="total"
      :pages="search.page"
      :pageSize="search.size"
      :delFIle="delUrl"
      :isLook="true"
      :axiosTile="axiosTile"
      :parentsList="parentsList"
      :editUrl="apiUrl.update"
      :deleteUrl="apiUrl.delete"
      :saveUrl="apiUrl.save"
      ref="table"
      @lookVideo="lookVideo"
      @editRichText="editRichText"
      :isSelect="true"
      @lookSubList="lookSubList"
    />
    <dataFillDialog
      :data="editOpen"
      @clearData="clearData"
      @pushData="updateData"
      :parentsList="parentsList"
      :isLook="false"
      ref="dialog"
    ></dataFillDialog>
    <lookVideoDialog ref="lookDialog"></lookVideoDialog>
    <RichEditor
      ref="richText"
      @handlerLoadList="handlerClose"
      :isDataFill="true"
    ></RichEditor>
    <!--批量标签话题编辑弹窗-->
    <batch-tags-popup
      ref="batchTagsPopup"
      type="movie"
      @handlerClose="handlerClose"
    ></batch-tags-popup>
    <add-remote-dialog ref="addRemoteDialog"></add-remote-dialog>
    <bind-actor-dialog ref="bindActorDialog"></bind-actor-dialog>
    <acg-sub-list ref="acgSubList" :visible.sync="acgSubListVisible" :mediaId="acgMediaId" @lookVideo="lookVideo"></acg-sub-list>
  </div>
</template>

<script>
import dataFillTable from "./components/dataFillTable";
import dataFillDialog from "./components/dataFillDialog.vue";
import search from "./components/search";
import lookVideoDialog from "../medium/components/lookVideoDialog";
import RichEditor from "@/components/rich-editor";
import BatchTagsPopup from "./components/batchTagsPopup";
import AddRemoteDialog from "./components/addRemoteDialog";
import BindActorDialog from "../medium/components/bindActorDialog";
import acgSubList from "./components/acgSubList";
import API from "@/api";
// import local from "@/utils/localStroage.js";

export default {
  name: "videoPage",
  components: {
    dataFillTable,
    dataFillDialog,
    search,
    lookVideoDialog,
    RichEditor,
    BatchTagsPopup,
    AddRemoteDialog,
    BindActorDialog,
    acgSubList,
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
        end_at: this.getLastMonthDate(),
        media_type: 1
      },
      axiosTile: "",
      delUrl: "/api/video/destroy",
      editOpen: {},
      total: 0,
      headerList: [
        {
          key: "任务ID",
          value: "id",
          align: "center",
          width: "120",
        },
        {
          key: "ID",
          value: "video_id",
          align: "center",
        },
        {
          key: "标题",
          value: "title",
          minWidth: "350",
        },
        //   {
        //     key: "演员",
        //     value: "actor",
        //     align: "center",
        //   },
        {
          key: "原封面",
          value: "o_cover",
          type: "image",
          align: "center",
        },
        //   {
        //     key: "正片预览",
        //     value: "is_preview",
        //     align: "center",
        //   },
        {
          key: "横版封面",
          value: "h_cover",
          type: "image",
          align: "center",
        },
        {
          key: "竖版封面",
          value: "v_cover",
          type: "image",
          align: "center",
        },
        {
          key: "优先级",
          value: "urgent",
          align: "center",
          type: "dictionary",
          dictionary: [
            {
              key: 2,
              value: "高",
            },
            {
              key: 1,
              value: "中",
            },
            {
              key: 0,
              value: "低",
            },
          ],
        },
        {
          key: "对接人ID",
          value: "user_id",
          align: "center",
        },
        {
          key: "对接人名称",
          value: "nick_name",
          align: "center",
          minWidth: "100",
        },
        {
          key: "发布者",
          value: "publisher",
          align: "center",
        },
        {
          key: "描述",
          value: "desc",
          align: "center",
        },
        {
          key: "编辑者",
          value: "edit_by",
          align: "center",
        },
        // {
        //   key: "创建时间",
        //   value: "create_time",
        //   type: "time",
        //   align: "center",
        // },
        {
          key: "截止时间",
          value: "end_at",
          type: "end_time",
          align: "center",
        },
        {
          key: "审核时间",
          value: "pass_at",
          type: "time",
          align: "center",
        },
        // {
        //   key: "修改时间",
        //   value: "update_time",
        //   type: "time",
        //   align: "center",
        // },
        {
          key: "审核状态",
          value: "status",
          type: "status",
          align: "center",
          width: "100",
          dictionary: [
            { key: 0, value: "创作中" },
            { key: 1, value: "审核中" },
            { key: 2, value: "审核通过" },
            { key: 3, value: "拒绝" },
          ],
          fixed: true,
        },
      ],
      tableData: [],
      parentsList: [],
      isSearch: false,
      isRefesh: true,
      userInfo: undefined,
      apiUrl: {
        list: "/api/task/filling/list",
        update: "/api/task/filling/update",
        delete: "/api/task/filling/batch/delete",
        check: "/api/task/filling/pass",
        save: "/api/task/filling/save",
        batchUpdate: "/api/task/filling/batch/update",
        accept: "/api/task/filling/accept",
      },
      acgSubListVisible: false,
      acgMediaId: "",
    };
  },
  created() {
    // this.userInfo = local.get("userInfo");
    // let listRule = "/api/task/filling/list";
    // let obj = JSON.parse(
    //   JSON.parse(JSON.stringify(localStorage.getItem("btnPower")))
    // );
    // if (obj[listRule]) {
    //   this.isRefesh = true;
    // } else {
    //   this.isRefesh = false;
    // }
    this.getVideoList();
  },
  methods: {
    getLastMonthDate() {
      const now = new Date();
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      return lastMonth.getTime() / 1000;
    },
    // 批量上线
    async batchlaunch() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要上线的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      const { msg, code, data } = await API.onlineVideo({ ids: ids });
      if (!code) {
        this.$message.success(
          "成功上线" + data.success + "条数据，失败" + data.failure + "条"
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    // 批量设置标签
    async openSetTags() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量设置标签的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.batchTagsPopup.open(ids);
    },
    // 批量设置标签
    async batchSetTags() {
      console.log("设置标签");
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      // const { msg, code, data } = await API.onlineVideo({ ids: ids });
      // if (!code) {
      //   this.$message.success(
      //     "成功上线" + data.success + "条数据，失败" + data.failure + "条"
      //   );
      //   this.getVideoList(this.search.page);
      // } else {
      //   this.$message.error(msg);
      // }
    },
    // 批量下线
    async batchCheck() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要审核的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });

      // 先显示确认对话框
      this.$confirm("是否通过审核？", "批量审核", {
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        distinguishCancelAndClose: true,
        type: "info",
      })
        .then(() => {
          // 点击通过，直接调用接口
          this.handlebatchCheck(ids, "", true);
        })
        .catch((action) => {
          if (action === "cancel") {
            // 点击拒绝，弹出输入框让用户输入拒绝原因
            this.$prompt("请输入拒绝原因", "拒绝审核", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              inputPattern: /\S/,
              inputErrorMessage: "拒绝原因不能为空",
            })
              .then(({ value }) => {
                // 调用接口，传入拒绝原因和false表示拒绝
                this.handlebatchCheck(ids, value, false);
              })
              .catch(() => {
                // 用户取消输入拒绝原因
                this.$message.info("已取消操作");
              });
          }
        });
    },
    // 批量审核处理
    async handlebatchCheck(ids, refuse_reason, action) {
      const { msg, code } = await API.taskFillingPass({
        id: ids,
        reason: refuse_reason,
        pass: action,
      });
      console.log(code, 'code')
      if (!code) {
        const actionText = action ? "审核通过" : "审核拒绝";
        this.$message.success(
          `成功${actionText}`
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    refesh() {
      this.isRefesh ? this.getVideoList() : "";
    },
    // 获取列表数据
    async getSetsList() {
      // 获取视频列表
      const { data, code } = await API.taskFillingList(
        this.search,
        this.axiosTile
      );
      console.log(data, "data", code);
      if (!code) {
        this.tableData = data.data;
        this.total = data.pagination.count;
        this.$refs.table.loading = false;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$refs.table.loading = false;
      }
    },
    clearData() {
      this.$refs.dialog.openDialog = false;
      this.editOpen = {};
    },
    async updateData(data) {
      console.log(data, "data");
      const { code, msg } = await API.taskFillingSave({
        h_cover: data.h_cover,
        v_cover: data.v_cover,
        id: data.id,
      });
      if (!code) {
        this.$message.success("保存成功");
        this.getVideoList(this.search.page);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      } else {
        this.$message.error(msg);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      }
    },
    editData(data) {
      this.editOpen = JSON.parse(JSON.stringify(data));
      this.$refs.dialog.openDialog = true;
      this.$refs.dialog.loadVideo(data.src, data);
      this.$refs.dialog.delUrl = this.delUrl;
      // this.$refs.dialog.getTargetTree();
    },
    async deleteData() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要删除的数据" });
        return false;
      }
      // 显示确认弹窗
      this.$confirm("确定要一键删除吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = [];
          this.$refs.table.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          console.log(ids, "ids");
          // 用户确认后执行删除
          const { code, msg } = await API.taskFillingBatchDelete({ ids: ids });
          if (!code) {
            this.$message.success("一键删除成功");
            this.getVideoList(this.search.page);
            this.$refs.dialog.loading = false;
          } else {
            this.$message.error(msg);
            this.$refs.dialog.loading = false;
          }
        })
        .catch(() => {
          // 用户取消删除
          //   this.$message.info('已取消删除操作');
        });
    },
    searchData(data) {
      this.search = { page: 1, size: 10 };
      if (this.isRefesh) {
        data
          ? (this.search = Object.assign(this.search, data))
          : (this.search = { page: 1, size: 10 });
        this.getVideoList();
      }
    },
    // 获取连载视频--连载视频弹框父级字段  视频管理--连载名称字段
    async getVideoList(page) {
      this.search.page = page || 1;
      this.isRefesh
        ? this.$nextTick(() => {
            this.$refs.table.loading = true;
          })
        : "";
      this.isRefesh ? this.getSetsList() : "";
    },
    lookVideo(data) {
      this.$refs.lookDialog.openlookDialog = true;
      this.$refs.lookDialog.loadVideo(data.src || data.m3u8_url, data);
    },
    editRichText(data) {
      this.$refs.richText.open(data);
    },
    async changeSize(pageSize) {
      this.search.page = 1;
      this.search.size = pageSize;
      this.getSetsList();
    },
    handlerClose() {
      this.getSetsList();
    },
    remoteVisual() {
      console.log("远程视觉");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量更新的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, "更新远程视觉", "remote_visual");
    },
    remoteOperation() {
      console.log("远程运营");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量更新的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, "edit", "remote_visual");
    },
    bindActor() {
      console.log("绑定演员");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量添加演员的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.bindActorDialog.open(ids);
    },
    async handlerSubmitRichText(data) {
      console.log(data, "data");
      const { code, msg } = await API.taskFillingSave({
        rich_text: data.rich_text,
        id: data.id,
      });
      if (!code) {
        this.$message.success("保存成功");
        this.getVideoList(this.search.page);
        this.$refs.richText.handleClose();
        this.$refs.richText.handleLookClose();
      } else {
        this.$message.error(msg);
        this.$refs.richText.handleClose();
        this.$refs.richText.handleLookClose();
      }
    },
    async acceptData() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要接单的数据" });
        return false;
      }
      
      // 添加确认弹窗
      this.$confirm('确定要接单选中的数据吗？', '确认接单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let ids = [];
        this.$refs.table.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        const { code, msg } = await API.taskFillingAccept({ ids: ids });
        console.log(code, 'code', msg);
        if (!code) {
          this.$message.success("接单成功");
          this.getVideoList(this.search.page);
        } else {
          this.$message.error(msg);
        }
      }).catch(() => {
        // this.$message.info('已取消接单');
      });
    },
    lookSubList(data) {
      this.acgMediaId = data.video_id;  
      this.acgSubListVisible = true;
    },
  },
};
</script>

<style scoped></style>
